import React, { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Api } from "../../../../Admin/BackendApi/api";
import "./UserOtp.css";

const UserOtp = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const mobile = state?.mobile || "";
  const userId = state?.userId || "";

  const [otp, setOtp] = useState(["", "", "", ""]);
  const [showSuccess, setShowSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [timer, setTimer] = useState(60);
  const [resendLoading, setResendLoading] = useState(false);
  const [resendMsg, setResendMsg] = useState("");

  const inputRefs = useRef([]);

  // ⏱ TIMER START WHEN PAGE LOADS
  useEffect(() => {
    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev === 0) return 0;
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const handleChange = (value, index) => {
    const newOtp = [...otp];
    newOtp[index] = value.slice(-1);
    setOtp(newOtp);

    if (value && index < 3) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  // VERIFY OTP API CALL
  const handleVerify = async () => {
    const fullOtp = otp.join("");

    if (fullOtp.length !== 4) {
      setError("Please enter complete 4-digit OTP");
      return;
    }

    try {
      setError("");
      setLoading(true);

      const response = await axios.post(Api.verifyOtp, {
        UserId: userId,
        OTP: fullOtp,
      });
      console.log("UserId", userId)
      console.log("Verify Response:", response.data);

      if (response.data.status === 1) {
        const token = response.data.user.Authtoken; // Assuming backend sends token in this format

        localStorage.setItem("userId", userId);

        // (Optional) If backend sends token:
        localStorage.setItem("token", token);
        console.log("token", token)

        setShowSuccess(true);

        setTimeout(() => {
          setShowSuccess(false);
          navigate("/user/dashboard");
        }, 2000);

      } else {
        setError(response.data.message || "Invalid OTP");
        setLoading(false);
      }

    } catch (err) {
      console.log(err);
      setError("Server error. Try again.");
      setLoading(false);
    }
  };
  // RESEND OTP FUNCTION
  const handleResendOtp = async () => {
    if (timer !== 0) return;

    try {
      setResendLoading(true);
      setResendMsg("");

      const response = await axios.post(Api.resendOtp, {
        Mobile: mobile,
      });

      if (response.data.status === 1) {
        setResendMsg("OTP resent successfully");
        setTimer(60); // restart timer
      } else {
        setResendMsg(response.data.message || "Failed to resend OTP");
      }
    } catch (err) {
      setResendMsg("Server error. Try again.");
    } finally {
      setResendLoading(false);
    }
  };

  return (
    <div className="user-otp-container">
      <h2>Enter OTP</h2>
      <p>
        OTP sent to <strong>{mobile}</strong>
      </p>

      <div className="user-otp-boxes">
        {otp.map((digit, index) => (
          <input
            key={index}
            type="tel"
            maxLength="1"
            value={digit}
            ref={(el) => (inputRefs.current[index] = el)}
            onChange={(e) => handleChange(e.target.value, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            className="user-otp-input"
          />
        ))}
      </div>

      {error && <div className="user-error-msg">{error}</div>}

      <button
        className="user-verify-button"
        onClick={handleVerify}
        disabled={loading}
      >
        {loading ? "Verifying..." : "Verify"}
      </button>

      <div className="resend-section">
        {timer === 0 ? (
          <button
            className="resend-btn"
            onClick={handleResendOtp}
            disabled={resendLoading}
          >
            {resendLoading ? "Sending..." : "Resend OTP"}
          </button>
        ) : (
          <p className="resend-timer">
            Resend OTP in <b>00:{timer.toString().padStart(2, "0")}</b>
          </p>
        )}

        {resendMsg && <p className="resend-msg">{resendMsg}</p>}
      </div>
      {showSuccess && (
        <div className="user-success-overlay">
          <div className="user-success-animation">

            <svg
              className="user-checkmark"
              viewBox="0 0 52 52"
            >
              <circle
                className="user-checkmark-circle"
                cx="26"
                cy="26"
                r="24"
              />
              <path
                className="user-checkmark-check"
                fill="none"
                d="M14 27l7 7 16-16"
              />
            </svg>

            <p className="user-success-message">
              OTP Verified Successfully!
            </p>

          </div>
        </div>
      )}


      <div className="user-version-text">Version 1.0</div>
    </div>
  );
};

export default UserOtp;
